import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.528 12.5l-4-2.4a4 4 0 1 1 .704-.744l4.268 2.56 9.743-5.845c.571-.343 1.086.515.514.858L13.472 12.5l9.285 5.571a.5.5 0 0 1-.514.858L12.5 13.083l-4.267 2.56a4 4 0 1 1-.704-.744l4-2.399zM5 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
});

var SvgScissors = function SvgScissors(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgScissors;